import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSlidersH } from "react-icons/fa";
import { baseurl } from "../Baseurl";
import axios from "axios";
import Swal from "sweetalert2";

export default function NotificationSetting() {
  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
  const orgId = localStorage.getItem("organization_id");

  // Default notification channels and event triggers
  const [notificationChannels, setNotificationChannels] = useState([
    { label: "Email", isToggled: false, hasSettings: true },
    { label: "In-app (dashboard pop ups)", isToggled: false },
  ]);

  const [eventTriggers, setEventTriggers] = useState([
    { label: "Task overdue", isToggled: false },
    { label: "Upcoming deadline", isToggled: false },
    { label: "New comments on tasks", isToggled: false },
    { label: "Status change", isToggled: false },
  ]);

  // Load admin & theme on mount
  useEffect(() => {
    const adminId = localStorage.getItem("adminID");
    if (!adminId) navigate("/");

    const savedTheme = localStorage.getItem("darkMode") === "true";
    setDarkMode(savedTheme);
    document.body.classList.toggle("dark", savedTheme);

    // Fetch saved notification settings
    const fetchSettings = async () => {
      try {
        const res = await axios.post(`${baseurl}upsertNotificationSetting`, { orgId });
        const savedSettings = res.data.data;

        // Update notificationChannels
        setNotificationChannels((prev) =>
          prev.map((ch) => {
            const saved = savedSettings.find(
              (s) => s.type === "channel" && s.label === ch.label
            );
            return saved ? { ...ch, isToggled: saved.is_toggled } : ch;
          })
        );

        // Update eventTriggers
        setEventTriggers((prev) =>
          prev.map((ev) => {
            const saved = savedSettings.find(
              (s) => s.type === "event" && s.label === ev.label
            );
            return saved ? { ...ev, isToggled: saved.is_toggled } : ev;
          })
        );
      } catch (err) {
        console.error("Failed to fetch notification settings:", err);
      }
    };

    fetchSettings();
  }, [navigate, orgId]);

  // Toggle channel
  const toggleNotificationChannel = async (index) => {
    const updated = [...notificationChannels];
    updated[index].isToggled = !updated[index].isToggled;
    setNotificationChannels(updated);

    const payload = {
      adminID: localStorage.getItem("adminID"),
      type: "channel",
      label: updated[index].label,
      isToggled: updated[index].isToggled,
      orgId,
    };

    try {
      const response = await axios.post(`${baseurl}upsertNotificationSetting`, payload);
      console.log("✅ Server response:", response.data);

      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Channel setting updated!",
        showConfirmButton: false,
        timer: 2000,
        background: "#28a745",
        color: "#fff",
      });
    } catch (error) {
      console.error("❌ Error updating channel setting:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to update channel setting",
        showConfirmButton: false,
        timer: 2000,
        background: "#dc3545",
        color: "#fff",
      });
    }
  };

  // Toggle event
  const toggleEventTrigger = async (index) => {
    const updated = [...eventTriggers];
    updated[index].isToggled = !updated[index].isToggled;
    setEventTriggers(updated);

    const payload = {
      adminID: localStorage.getItem("adminID"),
      type: "event",
      label: updated[index].label,
      isToggled: updated[index].isToggled,
      orgId,
    };

    try {
      await axios.post(`${baseurl}upsertNotificationSetting`, payload);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "success",
        title: "Event trigger updated!",
        showConfirmButton: false,
        timer: 2000,
        background: "#28a745",
        color: "#fff",
      });
    } catch (error) {
      console.error("❌ Error updating event trigger:", error);
      Swal.fire({
        toast: true,
        position: "top-end",
        icon: "error",
        title: "Failed to update event trigger",
        showConfirmButton: false,
        timer: 2000,
        background: "#dc3545",
        color: "#fff",
      });
    }
  };

  return (
    <>
      <div className="settings-header">
        <h3 className={`mainttl ${darkMode ? "dark" : ""}`}>Notifications & Alerts</h3>
      </div>

      <div className="settings-section">
        <h4 className="section-title">Notification Channels</h4>
        {notificationChannels.map((item, index) => (
          <div key={index} className="toggle-item">
            <span className="toggle-label">{item.label}</span>
            <div className="toggle-controls">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={item.isToggled}
                  onChange={() => toggleNotificationChannel(index)}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        ))}
      </div>

      <div className="settings-section">
        <h4 className="section-title">Event Triggers</h4>
        {eventTriggers.map((item, index) => (
          <div key={index} className="toggle-item">
            <span className="toggle-label">{item.label}</span>
            <div className="toggle-controls">
              <label className="switch">
                <input
                  type="checkbox"
                  checked={item.isToggled}
                  onChange={() => toggleEventTrigger(index)}
                />
                <span className="slider round"></span>
              </label>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
